import { mkdirp, mkdirpSync } from "fs-extra/lib/mkdirs/index.js"

export default mkdirp
export { mkdirpSync as sync }
